import React, { Component } from "react";
import config from "../config.json";
import authService from "../services/authService";
import ideaService from "../services/ideaService.js";
import $ from "jquery";
import "datatables.net-bs4";
import moment from "moment";
import DeleteButton from "./DeleteButton";
import ReactDOM from "react-dom";
import Swal from "sweetalert2";
import IdeaForm from "./IdeaForm";

import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";

class Admin extends Component {
  reloadDataTable() {
    $("#tblData").DataTable().ajax.reload();
  }
  loadDataTable() {
    $("#tblData").DataTable({
      ajax: {
        url: config.apiEndpoint + "ideas/all",
        type: "GET",
        datatype: "json",
        beforeSend: function (request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + authService.getToken()
          );
        },
        dataSrc: function (r) {
          return r.ideas;
        },
      },

      order: [[5, "desc"]],
      columns: [
        {
          data: "title",
          createdCell: (td, cellData, rowData, row, col) => {
            ReactDOM.render(
              <div>
                <IdeaForm
                  onSubmit={(idea) => this.reloadDataTable()}
                  mode="edit"
                  ideaId={rowData.id}
                  linkTitle={cellData}
                ></IdeaForm>
              </div>,
              td
            );
          },
          width: "15%",
        },
        {
          data: "active",
          render: function (data, type, row) {
            return data
              ? '<span class="badge badge-success">Active</span>'
              : '<span class="badge badge-secondary">Inactive</span>';
          },
          width: "5%",
        },
        {
          data: "status",
          render: function (data, type, row) {
            if (data === "Development in Process") {
              return '<span class="badge badge-primary">' + data + "</span>";
            } else if (data === "Under Consideration") {
              return '<span class="badge badge-warning">' + data + "</span>";
            } else {
              return '<span class="badge badge-success">' + data + "</span>";
            }
          },
          width: "5%",
        },
        { data: "module", width: "10%" },
        {
          data: "description",
          width: "20%",
          render: function (data, type, row, meta) {
            var sanitized = $.fn.dataTable.render
              .text()
              .display(data, type, row, meta);
            return sanitized.substring(0, 100);
          },
        },
        { data: "totalVotes", width: "10%", className: "text-right" },
        { data: "manualAdjustment", width: "10%", className: "text-right" },
        {
          data: "created",
          width: "15%",
          type: "date",
          render: function (data, type, row) {
            return data ? moment(data).format("DD MMM YYYY HH:mm") : "";
          },
        },
        {
          data: "id",
          createdCell: (td, cellData, rowData, row, col) => {
            ReactDOM.render(
              <DeleteButton
                ideaId={cellData}
                onDelete={() => this.deleteIdea(cellData)}
              ></DeleteButton>,
              td
            );
          },
          width: "15%",
        },
      ],
      language: {
        emptyTable: "No records found",
      },
      width: "100%",
    });
  }
  state = {};
  componentDidMount() {
    this.loadDataTable();
  }
  deleteIdea(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this item!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.value) {
        await ideaService.deleteIdea(id);
        Swal.fire("Deleted!", "", "success").then(this.reloadDataTable());
      }
    });
  }
  render() {
    return (
      <div className="container">
        <div className="card-list-head p-1">
          <IdeaForm
            onSubmit={() => this.reloadDataTable()}
            mode="new"
          ></IdeaForm>
        </div>
        <table
          id="tblData"
          className="table table-striped table-bordered w-100"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Active</th>
              <th>Status</th>
              <th>Module</th>
              <th>Description</th>
              <th>Votes</th>
              <th>Adjustment</th>
              <th>Added</th>
              <th></th>
            </tr>
          </thead>
        </table>
      </div>
    );
  }
}

export default Admin;
